import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Container } from '@mui/material';

import { ICustomerDetails } from "../../../types/customer";

import { AppSettingService } from "../../../services/appSettingService";
import { useListContext } from "../../../contexts/listContext";
import { useUserContext } from "../../../contexts/userContext";

import PermissionGate from "../../permissionGate";
import Navigation from "../../header";
import CustomerDetailsForm from "../../forms/customerDetailsForm";
import { Icons } from "../../icons";
import dayjs from "dayjs";

const CustomerAdd = () => {
	const userContext = useUserContext();
	const listContext = useListContext();
	const [brandswithApiKeys, setBrandsWithApiKeys] = useState<string[] | undefined>();

	useEffect(() => {
		loadAppSettings();
	}, [])

	const [formFields, setFormFields] = useState<ICustomerDetails>({
		brandId: "",
		epaId: "",
		generatorStatusId: "",
		name: "",
		notes: "",
		statusId: listContext.customerStatuses[0].value,
		wasteCertification: false,
		closedThroughDate: dayjs().add(-1, 'day').startOf('day').toDate()
	});

	const loadAppSettings = async () => {
		const brandsSetting = (await AppSettingService.getAppSettingByName("BrandsRequiringApiKeys"))?.data;
		setBrandsWithApiKeys(AppSettingService.mapAppSetting(brandsSetting).valueAsString().split(",").filter(b => b?.length > 0).map(b => b.trim()));
	}

	const reset = async () => {
		setFormFields({
			brandId: "",
			epaId: "",
			generatorStatusId: "", 
			name: "",
			notes: "",
			statusId: listContext.customerStatuses[0].value,
			wasteCertification: false,
			closedThroughDate: dayjs().add(-1, 'day').startOf('day').toDate()
		});
	}

	return (
		<div className="hwi-customer-add">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageCustomers}>
					<section className="management-page-header">
						<div className="title">
							<NavLink to="/customer">
								<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
							</NavLink>
							Add Customer
						</div>
					</section>
					<section className="management-page-form">
						<CustomerDetailsForm action="add" details={formFields} brandsRequiringApiKeys={brandswithApiKeys} reloadData={reset} ></CustomerDetailsForm>
					</section>
				</PermissionGate>
			</Container>
		</div>
	);
};

export default CustomerAdd;